import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import InvoiceStatusForm from '../../../components/forms/InvoiceStatusForm';
import { useInvoiceStatusApi } from '../../../hooks/useInvoiceStatusApi';
import { useNavigate } from 'react-router-dom';
import { InvoiceStatusDTO } from '../../../services/apiClient';

const InvoiceStatusCreate: React.FC = () => {
  const { create, isLoading } = useInvoiceStatusApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Invoice Statuses', href: '/admin/invoicestatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: InvoiceStatusDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/invoicestatuses');
    } catch (error) {
      console.error('Error creating InvoiceStatus:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/invoicestatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.InvoiceStatus.Edit'
    >
        <InvoiceStatusForm
          initialValues={{} as InvoiceStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/invoicestatuses')}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default InvoiceStatusCreate;